import { Controller } from '@hotwired/stimulus';



let documentListenersBound = false;



function isInteractiveTarget(target, flyoutTrigger = null) {
	const interactive = target.closest('button, a, input, select, textarea, label, [data-controller="tippy"]');

	if (!interactive) {
		return false;
	}

	// Allow flyout triggers nested in a label (e.g. plan-toggle__label).
	if (
		flyoutTrigger
		&& interactive.matches('label')
		&& interactive.contains(flyoutTrigger)
	) {
		return false;
	}

	return true;
}



function openFlyoutPanel(flyoutId) {

	const panel = document.getElementById(`popupFlyoutModal${flyoutId}`);



	if (!panel) {

		return;

	}



	const panelController = window.application?.getControllerForElementAndIdentifier(panel, 'popup-flyout');



	if (panelController) {

		panelController.show();

		return;

	}



	panel.style.display = 'block';

	document.documentElement.classList.add('modal-visible');



	requestAnimationFrame(() => {

		panel.classList.add('modal-show');

	});

}



function handleFlyoutTriggerClick(event) {

	const trigger = event.target.closest('.plan-benefit--has-flyout[data-flyout-id]');



	if (!trigger) {

		return;

	}



	if (isInteractiveTarget(event.target, trigger)) {

		return;

	}



	event.preventDefault();

	event.stopPropagation();

	openFlyoutPanel(trigger.dataset.flyoutId);

}



function handleFlyoutTriggerKeydown(event) {

	if (event.key !== 'Enter' && event.key !== ' ') {

		return;

	}



	const trigger = event.target.closest('.plan-benefit--has-flyout[data-flyout-id]');



	if (!trigger || !trigger.contains(event.target)) {

		return;

	}



	if (isInteractiveTarget(event.target, trigger)) {

		return;

	}



	event.preventDefault();

	openFlyoutPanel(trigger.dataset.flyoutId);

}



function bindDocumentListeners() {
	if (documentListenersBound) {
		return;
	}

	documentListenersBound = true;
	document.addEventListener('click', handleFlyoutTriggerClick);
	document.addEventListener('keydown', handleFlyoutTriggerKeydown);
}

export function bindFlyoutDocumentListeners() {
	bindDocumentListeners();
}



export default class extends Controller {

	connect() {

		bindDocumentListeners();

		this.connectPanel();

	}



	disconnect() {

		this.disconnectPanel();

	}



	connectPanel() {

		this.dialog = this.element.querySelector('.modal-dialog');

		this.content = this.element.querySelector('.modal-content');

		this.scrollContainer = this.element.querySelector('.modal-scroll-container');

		this.terms = this.element.querySelector('.popup-flyout-modal__terms');

		this.termsWrapper = this.element.querySelector('.popup-flyout-modal__terms-wrapper');



		this.onBackdropClick = this.onBackdropClick.bind(this);

		this.onCloseClick = this.onCloseClick.bind(this);

		this.onTransitionEnd = this.onTransitionEnd.bind(this);

		this.onContentClick = this.onContentClick.bind(this);

		this.onTermsScroll = this.onTermsScroll.bind(this);



		this.scrollContainer?.addEventListener('mousedown', this.onBackdropClick);

		this.content?.addEventListener('click', this.onContentClick);

		this.terms?.addEventListener('scroll', this.onTermsScroll);



		for (const close of this.element.querySelectorAll('.modal-close')) {

			close.addEventListener('click', this.onCloseClick);

		}



		this.updateTermsFade();

	}



	disconnectPanel() {

		this.scrollContainer?.removeEventListener('mousedown', this.onBackdropClick);

		this.content?.removeEventListener('click', this.onContentClick);

		this.terms?.removeEventListener('scroll', this.onTermsScroll);



		for (const close of this.element.querySelectorAll('.modal-close')) {

			close.removeEventListener('click', this.onCloseClick);

		}



		this.dialog?.removeEventListener('transitionend', this.onTransitionEnd);

	}



	onTermsScroll() {

		this.updateTermsFade();

	}



	updateTermsFade() {

		if (!this.terms || !this.termsWrapper) {

			return;

		}



		const atEnd = this.terms.scrollHeight - this.terms.scrollTop - this.terms.clientHeight <= 1;



		this.termsWrapper.classList.toggle('popup-flyout-modal__terms-wrapper--at-end', atEnd);

	}



	onBackdropClick(event) {

		if (event.target === this.scrollContainer) {

			this.hide();

		}

	}



	onCloseClick(event) {

		event.preventDefault();

		this.hide();

	}



	onContentClick(event) {

		event.stopPropagation();

	}



	show() {

		this.isHiding = false;

		this.element.style.display = 'block';

		document.documentElement.classList.add('modal-visible');



		requestAnimationFrame(() => {

			this.element.classList.add('modal-show');

			this.updateTermsFade();

		});

	}



	hide() {

		if (!this.element.classList.contains('modal-show')) {

			return;

		}



		this.isHiding = true;

		this.element.classList.remove('modal-show');

		document.documentElement.classList.remove('modal-visible');



		this.dialog?.removeEventListener('transitionend', this.onTransitionEnd);

		this.dialog?.addEventListener('transitionend', this.onTransitionEnd);



		window.setTimeout(() => {

			if (this.isHiding) {

				this.finishHide();

			}

		}, 350);

	}



	onTransitionEnd(event) {

		if (event.target !== this.dialog || event.propertyName !== 'transform') {

			return;

		}



		this.finishHide();

	}



	finishHide() {

		if (!this.isHiding) {

			return;

		}



		this.isHiding = false;

		this.element.style.display = 'none';

		this.dialog?.removeEventListener('transitionend', this.onTransitionEnd);

	}

}


